import { render, staticRenderFns } from "./FormIndex.vue?vue&type=template&id=99dda384"
import script from "./FormIndex.vue?vue&type=script&lang=js"
export * from "./FormIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports